import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import GBColor from '../../prop-types/GBColor';
import styles from './flipper.css';
var cx = classnames.bind(styles);

function FlipperFront(_ref) {
  var className = _ref.className,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["className", "color"]);

  return React.createElement("div", _extends({
    className: cx('front', color, className)
  }, rest));
}

FlipperFront.propTypes = {
  /** Class name to apply to component */
  className: PropTypes.string,

  /** Background color */
  color: GBColor
};
FlipperFront.defaultProps = {
  className: undefined,
  color: 'teal'
};

function FlipperBack(_ref2) {
  var className = _ref2.className,
      color = _ref2.color,
      rest = _objectWithoutProperties(_ref2, ["className", "color"]);

  return React.createElement("div", _extends({
    className: cx('back', color, className)
  }, rest));
}

FlipperBack.propTypes = {
  /** Class name to apply to component */
  className: PropTypes.string,

  /** Background color */
  color: GBColor
};
FlipperBack.defaultProps = {
  className: undefined,
  color: 'red'
};

function Flipper(_ref3) {
  var children = _ref3.children,
      className = _ref3.className,
      origin = _ref3.origin,
      vertical = _ref3.vertical,
      rest = _objectWithoutProperties(_ref3, ["children", "className", "origin", "vertical"]);

  return React.createElement("div", _extends({
    className: cx('container', {
      vertical: vertical
    }, origin, className)
  }, rest), React.createElement("div", {
    className: cx('flipper')
  }, children));
}

Flipper.propTypes = {
  /** Child content */
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** Class name to apply to component */
  className: PropTypes.string,

  /** String to identify side to rotate around */
  origin: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),

  /** Boolean to rotate the card on the X axis */
  vertical: PropTypes.bool
};
Flipper.defaultProps = {
  children: undefined,
  className: undefined,
  origin: undefined,
  vertical: false
};
Flipper.Front = FlipperFront;
Flipper.Back = FlipperBack;
export default Flipper;